module.exports = __webpack_public_path__ + "6587ed89047f7d1ca86eac80addda50f.pdf";